import { ExclamationMarkCircleFilled } from "components/icons/generated";
import Box from "ds/components/Box";
import Icon from "ds/components/Icon";
import Typography from "ds/components/Typography";
import { pluralize } from "shared/Pluralize";

type DriftDetectedLabelProps = {
  count: number;
};

const DriftDetectedLabel = ({ count }: DriftDetectedLabelProps) => {
  if (count <= 0) {
    return null;
  }

  return (
    <Box align="center" gap="small">
      <Icon src={ExclamationMarkCircleFilled} color="danger" noShrink />
      <Typography tag="span" variant="p-body3" color="secondary">
        {`${count} ${pluralize("drift", count)} detected`}
      </Typography>
    </Box>
  );
};

export default DriftDetectedLabel;
